import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal as EPModal } from '@elparking/components'
import BookingProductsModalContent from './BookingProductsModalContent'

const modalStyles = {
    content: {
        top: '0%',
        left: '0',
        right: '0',
        bottom: '0',
        marginRight: '0',
        overflow: 'auto',
        padding: '0',
        border: 'none',
        background: 'transparent',
        minHeight: '100%',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
    },
}

class BookingProductsModal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        onClose: PropTypes.func,
    }

    render () {
        const { isOpen, onClose, ...restProps } = this.props

        return (
            <EPModal
              style={modalStyles}
              label='BookingProductsModal'
              isShown={isOpen}
              showCloseButton
              showModalTitle={false}
              width='500px'
              onClose={onClose}
            >
                <BookingProductsModalContent {...restProps} />
            </EPModal>
        )
    }
}

export default BookingProductsModal
